export default {
  getProducts: (state) => state.products,
  getViewerLink: () => (item) => `${process.env.VUE_APP_APPURL}/paid/stream/${item.id}`,
};
